function convertWeekToYear(num) {
  let eq =
    "Converting " +
    num +
    " week to year: \n" +
    num +
    " * 0.019165349048919554 = ";
  let rep = num * 0.019165349048919554 ;
  return eq + rep.toFixed(4);
}

function convertWeekToSecond(num) {
  let eq =
    "Converting " + num + " week to second: \n" + num + " * 604800 = ";
  let rep = num * 604800;
  return eq + rep.toFixed(2);
}

function convertWeekToMonth(num) {
  let eq =
    "Converting " +
    num +
    " week to month: \n" +
    num +
    " * 0.22998418858703 = ";
  let rep = num * 0.22998418858703;
  return eq + rep.toFixed(3);
}

function convertWeekToMinute(num) {
  let eq =
    "Converting " +
    num +
    " week to minute: \n" +
    num +
    " * 10080 = ";
  let rep = num * 10080;
  return eq + rep.toFixed(2);
}

function convertWeekToHour(num) {
  let eq =
    "Converting " +
    num +
    " week to hour: \n" +
    num +
    " * 168 = ";
  let rep = num * 168;
  return eq + rep.toFixed(2);
}

function convertWeekToDay(num) {
  let eq =
    "Converting " +
    num +
    " week to day: \n" +
    num +
    " * 7 = ";
  let rep = num * 7;
  return eq + rep.toFixed(2);
}

export {
  convertWeekToDay,
  convertWeekToHour,
  convertWeekToMinute,
  convertWeekToMonth,
  convertWeekToSecond,
  convertWeekToYear
};
